import SuccessPage from "components/SuccessPage/SuccessPage"

const PurchaseSummary = () => {
  return <SuccessPage />
}

export default PurchaseSummary
